<template>
	<b-modal
		size="xl"
		id="resumeclinicmodal"
		hide-footer
		hide-header
		v-model="openresumeclinicModal"
		:centered="!isMobile"
		no-close-on-backdrop
		@hide="modalClose()"
		@shown="onModalShown"
	>
		<template
			v-if="
				(!firstModal &&
					!secondModal &&
					showfromhelpsection == false &&
					!Object.keys(clinicDatafromhs).length &&
					!checkIfResumeClinicAnalysisExists) ||
				gobacktoFirstmodal
			"
		>
			<section class="p-3 mobile-txt-center">
				<div class="d-flex align-items-center justify-content-between">
					<h5 class="color-2E425D mobw-100 fw-B font-manrope fs-18">
						Resume Clinic
					</h5>

					<img
						src="@/assets/newdesign/dashboard/blueCross.svg"
						class="on-modal-close pointer rotate-on-hover"
						alt=""
						@click="modalClose()"
						id="hideinmobile"
					/>
					<img
						src="@/assets/newdesign/resumeclinic/mobileclose.svg"
						class="mobilecloseicon pointer rotate-on-hover"
						alt=""
						@click="modalClose()"
						id="hideinlaptop"
					/>
				</div>
				<h6 class="text-lightgrey fs-14 fw-500 font-sans-pro mt-2">
					Get AI-driven insights and tailor your resume to match job
					descriptions for better ATS compatibility.
				</h6>
			</section>
			<hr class="rc-hr mt-0" id="hideinmobile" />
			<section
				class="mobile-txt-center place-center template3-height justify-content-center flex-column align-items-center w-100 overflow-auto mob-justify-unset mobpadding15px"
			>
				<div
					class="d-flex w-100 gap-3 mob-d-block"
					:class="{ 'justify-content-center': !jdchecked }"
				>
					<div
						class="w-50 mob-w100"
						:class="{
							'uplod-error-box': errorMessage,
							'rotating-border': !errorMessage && !fileName,
							'uploaded-green-border': fileName && !errorMessage,
						}"
					>
						<div
							class="res-card-content d-flex flex-column align-items-center position-relative"
						>
							<img
								v-if="fileName"
								src="@/assets/newdesign/resumeclinic/uploadedresume.svg"
								alt=""
							/>
							<img
								v-else
								src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/ResumeClinic/ResumeClinic-dp.svg"
								alt=""
							/>
							<span
								v-if="!fileName"
								class="fam-inter fs-16 mob-fs-14 fw-600 color-595959 w-75 my-3 mob-txt-center"
							>
								Click on upload your resume button to get started</span
							>
							<template v-if="fileName">
								<div
									class="w-75 mb-3 mt-4 fileinputcontainer d-flex justify-content-between align-items-center"
								>
									<div>
										<img
											src="@/assets/newdesign/resumeclinic/file.svg"
											alt=""
										/>
									</div>
									<div
										class="fs-18 fw-B fam-lato color-darkblue px-2 text-truncate"
									>
										{{ fileName }}
									</div>
									<div class="d-flex gap-2 align-items-center">
										<div class="position-relative">
											<img
												@click="triggerFileInput"
												class="pointer"
												src="@/assets/newdesign/resumeclinic/replace.svg"
												alt="Replace File"
											/>
											<input
												type="file"
												ref="fileInput"
												style="display: none"
												@change="handleFileUpload"
												accept=".pdf, .docx"
											/>
										</div>
										<img
											src="@/assets/newdesign/resumeclinic/line.svg"
											alt=""
										/>
										<img
											@click="deleteFile"
											class="pointer"
											src="@/assets/newdesign/resumeclinic/delete.svg"
											alt=""
										/>
									</div>
								</div>
							</template>

							<p
								v-if="errorMessage"
								class="text-red fw-500 mob-fs-12 fs-14 mb-4"
							>
								{{ errorMessage }}
							</p>
							<span
								v-else
								class="fw-500 mob-fs-12 fs-14 color-595959 font-style-italic mb-4"
								>PDF & DOCX only, Max file size is 10 MB</span
							>
							<template v-if="!fileName">
								<div class="primary-bluebtn resume-upload-btn">
									<b-button variant="primary" class="" @click="triggerFileInput"
										>Upload Your Resume</b-button
									>
								</div>
								<input
									type="file"
									ref="fileInput"
									style="display: none"
									@change="handleFileUpload"
									accept=".pdf,.docx"
								/>
							</template>
						</div>
					</div>
					<div class="w-50 mob-w100" v-if="jdchecked">
						<div class="resumeclinic-inputs mob-mt30px">
							<label class="color-2E425D fs-14 fw-B font-sans-pro"
								>Job Role</label
							>
							<b-form-input
								v-model="jobRole"
								placeholder="Please enter your job title here"
							></b-form-input>
						</div>
						<div class="resumeclinic-textarea mt-3">
							<label class="color-2E425D fs-14 fw-B font-sans-pro"
								>Job Description</label
							>
							<b-form-textarea
								v-model="jobDescription"
								placeholder="Enter the description..."
								rows="5"
								max-rows="6"
							></b-form-textarea>
						</div>
					</div>
				</div>
				<div
					class="mt-5 mob-w100 rc-compare-container position-relative d-flex align-items-center justify-content-center"
				>
					<b-form-checkbox v-model="jdchecked" name="check-button" switch>
					</b-form-checkbox>

					<div class="ml-2">
						<h5 class="fs-16 mob-fs-14 fw-B font-manrope text-blue">
							Compare with job description
						</h5>
						<h6
							class="fs-14 fw-400 mob-fs-12 font-sans-pro text-black mobmt-15px"
						>
							Get targeted insights against Job description with our AI checker
						</h6>
					</div>
					<img
						src="@/assets/newdesign/resumeclinic/star.svg"
						class="position-absolute top-0 right-0"
						alt=""
					/>
				</div>
			</section>
			<hr class="rc-hr mt-3 mb-0" />
			<footer
				class="primary-bluebtn p-3 d-flex align-items-center justify-content-end"
			>
				<b-button
					variant="primary"
					class="w-250px mob-w100"
					@click="uploadresume"
					:disabled="fileName == ''"
					>Continue</b-button
				>
			</footer>
		</template>

		<template
			v-else-if="
				(secondModal == true && firstModal == false) ||
				(showfromhelpsection == false &&
					firstModal == false &&
					!Object.keys(clinicDatafromhs).length &&
					!checkIfResumeClinicAnalysisExists) ||
				(!gobacktoFirstmodal &&
					!firstModal &&
					secondModal &&
					!showfromhelpsection)
			"
		>
			<section
				class="w-100 d-flex flex-column align-items-center justify-content-center h-100"
			>
				<div v-if="loaderStatus">
					<Spinner :id="'resumeclinic'" />
				</div>
			</section>
		</template>

		<template v-else>
			<div v-if="loaderStatus2">
				<Spinner :id="'resumemodal'" />
			</div>
			<section v-else>
				<section class="p-3 mobile-txt-center">
					<div class="d-flex align-items-center justify-content-between">
						<h5 class="color-2E425D mobw-100 fw-B font-manrope fs-18">
							Your results
						</h5>

						<img
							src="@/assets/newdesign/dashboard/blueCross.svg"
							class="on-modal-close pointer rotate-on-hover"
							alt=""
							@click="modalClose()"
							id="hideinmobile"
						/>
						<img
							src="@/assets/newdesign/resumeclinic/mobileclose.svg"
							class="mobilecloseicon pointer rotate-on-hover"
							alt=""
							@click="modalClose()"
							id="hideinlaptop"
						/>
					</div>
					<h6 class="text-lightgrey fs-14 fw-LM font-sans-pro mt-2">
						Check out the insights generated from your resume.
					</h6>
				</section>
				<hr class="rc-hr mt-0" id="hideinmobile" />

				<section
					class="mobile-txt-center d-flex justify-content-center mob-justify-unset flex-column align-items-center w-100"
				>
					<div
						class="template3-height mobh-unset d-flex w-100 gap-3 mob-d-block"
						style=""
					>
						<div class="w-30 mob-w100 p-3 h-100 overflow-auto">
							<div
								class="rc-result-left-top pt-3 d-flex flex-column mobflexrow justify-content-center align-items-center"
							>
								<div class="text-center">
									<h5 class="fs-16 fw-LM font-sans-pro text-white">
										Your Resume Score:
									</h5>
									<h3
										class="mt-2 fs-24 fw-800 font-manrope text-uppercase"
										:class="{
											'color-2AA869': overAllRating == 'Amazing',
											'color-F9C82B': overAllRating == 'Good',
											'color-e99e32': overAllRating == 'Okay',
											'color-d7342c': overAllRating == 'Fair',
										}"
									>
										{{ overAllRating }}
									</h3>
								</div>

								<div class="text-center position-relative mt-3 mobmt-0">
									<img
										src="../../assets/newdesign/resumeclinic/resumemeter.svg"
										alt=""
									/>
									<img
										class="position-absolute"
										src="https://cvstaticfiles.s3.ap-south-1.amazonaws.com/website/blackDial.svg"
										alt=""
										:class="getMeterClass"
									/>
								</div>
							</div>
							<div class=" " id="hideinmobile">
								<div
									v-if="
										candidateData &&
										candidateData.payload &&
										Object.keys(candidateData.payload).length
									"
								>
									<div
										v-for="([key, value], index) in sortedCandidateData"
										:key="index"
									>
										<div
											v-if="
												key !== 'uuid' &&
												key !== 'overall' &&
												key !== 'resume_vs_job' &&
												key !== 'candidate_name' &&
												key !== 'candidate_email'
											"
											class="mt-3 rc-result-top-cards pointer d-flex align-items-center justify-content-between"
											@click="scrollToAccordion(index)"
										>
											<div class="d-flex align-items-center">
												<div
													class="rc-res-left-card-boxes"
													:class="{
														'bg-boxgreen': value.rating == 1,
														'bg-boxyellow': value.rating == 2,
														'bg-boxorange': value.rating == 3,
														'bg-boxred': value.rating == 4,
													}"
												></div>
												<div
													class="ml-2 pt-1 fs-14 fw-500 font-sans-pro color-darkblack text-capitalize"
												>
													<span v-if="key === 'personal_info'">
														Personal Info</span
													>
													<span v-else> {{ key }}</span>
												</div>
											</div>
											<div class="d-flex gap-3 align-items-center">
												<div
													class="rc-reviewtag fs-12 fw-500 font-sans-pro"
													v-if="value.rating !== 1"
												>
													Review
												</div>
												<img
													src="@/assets/newdesign/resumeclinic/rightarw.svg"
													alt=""
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							v-if="
								candidateData &&
								candidateData.payload &&
								Object.keys(candidateData.payload).length
							"
							class="w-70 pr-3 mobp-3 h-100 overflow-xh-ya mob-w100 mr-1"
							:class="isApp ? 'mobh-thirdscreen-res-android' : 'mobh-thirdscreen-res'"
						>
							<section class="rc-result-right-top">
								<h3 class="fw-B fam-mont fs-16 text-white mobile-text-left">
									{{ candidateData.payload.overall.suggestions }}
								</h3>
								<div
									class="mobile-text-left rc-rrt-subbars my-3 fam-mont fw-LM fs-14 style-italic"
								>
									Key findings:-
								</div>
								<b-row class="mobile-text-left">
									<b-col cols="12" md="4" class="mb-3">
										<div class="info-card">
											<img
												v-if="candidateData.payload.overall.relavent_experience"
												src="@/assets/newdesign/resumeclinic/greentick.svg"
												alt=""
											/>
											<img
												v-else
												src="@/assets/newdesign/resumeclinic/redcross.svg"
												alt=""
											/>
											<span
												class="ml-1 fs-12 style-italic fam-mont text-white fw-M"
												>Relevance of Experience</span
											>
										</div>
									</b-col>

									<b-col cols="12" md="4" class="mb-3">
										<div class="info-card">
											<img
												v-if="
													candidateData.payload.overall
														.relavent_career_progression
												"
												src="@/assets/newdesign/resumeclinic/greentick.svg"
												alt=""
											/>
											<img
												v-else
												src="@/assets/newdesign/resumeclinic/redcross.svg"
												alt=""
											/>
											<span
												class="ml-1 fs-12 style-italic fam-mont text-white fw-M"
												>Career Progression</span
											>
										</div>
									</b-col>
									<b-col cols="12" md="4" class="mb-3">
										<div class="info-card">
											<img
												v-if="candidateData.payload.overall.relavent_education"
												src="@/assets/newdesign/resumeclinic/greentick.svg"
												alt=""
											/>
											<img
												v-else
												src="@/assets/newdesign/resumeclinic/redcross.svg"
												alt=""
											/>
											<span
												class="ml-1 fs-12 style-italic fam-mont text-white fw-M"
												>Educational Relevance</span
											>
										</div>
									</b-col>
									<b-col cols="12" md="4" class="mb-3">
										<div class="info-card">
											<img
												v-if="
													candidateData.payload.overall
														.relavent_industry_or_domain
												"
												src="@/assets/newdesign/resumeclinic/greentick.svg"
												alt=""
											/>
											<img
												v-else
												src="@/assets/newdesign/resumeclinic/redcross.svg"
												alt=""
											/>
											<span
												class="ml-1 fs-12 style-italic fam-mont text-white fw-M"
												>Industry Knowledge</span
											>
										</div>
									</b-col>
									<b-col cols="12" md="4" class="mb-3">
										<div class="info-card">
											<img
												v-if="candidateData.payload.overall.relavent_skill"
												src="@/assets/newdesign/resumeclinic/greentick.svg"
												alt=""
											/>
											<img
												v-else
												src="@/assets/newdesign/resumeclinic/redcross.svg"
												alt=""
											/>
											<span
												class="ml-1 fs-12 style-italic fam-mont text-white fw-M"
												>Gaps in Experience
											</span>
										</div>
									</b-col>
								</b-row>

								<div
									v-if="suggestedJobs.length != 0"
									class="mobile-text-left rc-rrt-subbars my-3 fam-mont fw-LM fs-14 style-italic"
								>
									Suggested Job roles:-
								</div>
								<article
									class="d-flex suggestedjobs flex-wrap pl-1 gap-3 align-items-center pb-2"
								>
									<div
										v-for="(job, index) in visibleJobs"
										:key="index"
										class="rc-suggested-tags fs-14 fw-R fam-mont text-white"
									>
										{{ job.title }}
										<img
											class="ml-2 pointer"
											src="@/assets/newdesign/resumeclinic/overview.svg"
											alt=""
											@click="
												gotoParticularJob(job.jobID, candidateData.payload.uuid)
											"
										/>
									</div>

									<div
										v-if="remainingCount > 0"
										class="fam-lato fw-B fs-14 text-white pointer"
										@click="openLoginAndGoToJobs()"
									>
										+{{ remainingCount }} more
									</div>
								</article>

								<!-- <article
									class="d-flex flex-wrap gap-3 align-items-center"
									v-else
								>
									<div
										v-for="(job, index) in suggestedCopy"
										:key="index"
										class="rc-suggested-tags fs-14 fw-R fam-mont text-white"
									>
										{{ job.title }}
										<img
											class="ml-2 pointer"
											src="@/assets/newdesign/resumeclinic/overview.svg"
											alt=""
											@click="gotoParticularJob(job.jobID)"
										/>
									</div>
									<div class="fam-lato fw-B fs-14 text-white pointer">
										<span class="text-underline mr-1" @click="showAll = false"
											>Show less</span
										>
										<img
											src="@/assets/newdesign/resumeclinic/downarw.svg"
											alt=""
										/>
									</div>
								</article> -->
							</section>

							<section class="mt-3">
								<div class="accordioncards" role="tablist">
									<div
										v-if="
											candidateData &&
											candidateData.payload &&
											Object.keys(candidateData.payload).length
										"
									>
										<b-card
											no-body
											class="mb-2 pointer"
											v-for="([key, value], index) in sortedCandidateData"
											:key="index"
											:ref="'accordion-' + index"
											:class="
												key !== 'overall' &&
												key !== 'uuid' &&
												key !== 'candidate_name' &&
												key !== 'candidate_email'
													? ''
													: 'noborder'
											"
											@click="toggleAccordion(index)"
										>
											<b-card-header
												v-if="
													key !== 'overall' &&
													key !== 'uuid' &&
													key !== 'resume_vs_job' &&
													key !== 'candidate_name' &&
													key !== 'candidate_email'
												"
												header-tag="header"
												class="d-flex align-items-center justify-content-between"
												role="tab"
											>
												<div
													class="text-capitalize fam-mont fs-16 fw-M color-2E425D"
												>
													<img
														v-if="imageMap[key]"
														:src="imageMap[key]"
														alt="icon"
													/>

													<span v-if="key === 'personal_info'">
														Personal Info</span
													>
													<span v-else> {{ key }}</span>
												</div>
												<div class="d-flex align-items-center gap-3">
													<div
														class="parsedtagsize"
														:class="{
															fairtag: value.rating == 4,
															goodtag: value.rating == 2,
															okaytag: value.rating == 3,
															amzngtag: value.rating == 1,
														}"
													>
														<span v-if="value.rating == 1">AMAZING</span>
														<span v-if="value.rating == 2">GOOD</span>
														<span v-if="value.rating == 3">OKAY</span>
														<span v-if="value.rating == 4">FAIR</span>
													</div>
													<img
														v-if="!activeAccordion[index]"
														:id="'toggle-btn-' + index"
														src="@/assets/newdesign/resumeclinic/bluedownarw.svg"
														alt=""
														class="pointer"
													/>
													<img
														v-else
														:id="'toggle-btn-' + index"
														src="@/assets/newdesign/resumeclinic/blueuparw.svg"
														alt=""
														class="pointer"
													/>
												</div>
											</b-card-header>

											<b-collapse
												:id="'accordion-' + index"
												v-model="activeAccordion[index]"
												accordion="my-accordion"
												role="tabpanel"
												:class="
													(key === 'projects' ||
														key === 'skills' ||
														key === 'endeavours') &&
													!hasAccess()
														? 'blurbackground'
														: ''
												"
											>
												<b-card-body class="position-relative">
													<b-card-text v-if="value.suggestions">
														{{ value.suggestions }}
													</b-card-text>
													<b-card-text v-else class="text-center">
														No suggestions available.
													</b-card-text>
													<div
														class="unlockbtn primary-bluebtn position-absolute"
													>
														<b-button
															variant="primary"
															v-if="
																(key === 'projects' ||
																	key === 'skills' ||
																	key === 'endeavours') &&
																!hasAccess()
															"
															@click="
																openLoginModal(candidateData.payload.uuid)
															"
														>
															<svg
																width="12"
																height="15"
																viewBox="0 0 12 15"
																fill="none"
																xmlns="http://www.w3.org/2000/svg"
																class="mr-2"
															>
																<path
																	d="M10.15 6.05H9.6V3.85C9.6 1.87 8 0.25 6 0.25C4 0.25 2.4 1.87 2.4 3.85V6.05H1.85C0.83 6.05 0 6.88 0 7.9V12.4C0 13.42 0.83 14.25 1.85 14.25H10.15C11.17 14.25 12 13.42 12 12.4V7.9C12 6.88 11.17 6.05 10.15 6.05ZM3.85 3.85C3.85 2.66 4.81 1.7 6 1.7C7.19 1.7 8.15 2.66 8.15 3.85V6.05H3.85V3.85ZM10.55 12.4C10.55 12.62 10.37 12.8 10.15 12.8H1.85C1.63 12.8 1.45 12.62 1.45 12.4V7.9C1.45 7.68 1.63 7.5 1.85 7.5H10.15C10.37 7.5 10.55 7.68 10.55 7.9V12.4ZM6 11.35C6.8 11.35 7.45 10.7 7.45 9.9C7.45 9.1 6.8 8.45 6 8.45C5.2 8.45 4.55 9.1 4.55 9.9C4.55 10.7 5.2 11.35 6 11.35Z"
																	fill="white"
																/>
															</svg>
															Unlock now
														</b-button>
													</div>
												</b-card-body>
											</b-collapse>
										</b-card>
									</div>
								</div>
							</section>
							<section class="mt-3" v-if="visibleCards.length != 0">
								<h5 class="fw-B fs-16 font-manrope color-black mob-txt-left">
									Check out job listings for you
								</h5>
								<div
									class="d-flex gap-3 joblistingcards overflow-auto moboverflowx-auto w-100 mt-3"
									ref="jobscrollContainer"
								>
									<div class="d-flex gap-3 w-100" :key="currentIndex">
										<b-card v-for="(item, index) in visibleCards" :key="index">
											<h5
												class="color-2E425D font-marope fw-M fs-16 text-truncate text-capitalize"
											>
												<span
													v-b-tooltip.hover="{ title: item.title }"
													style="max-width: 100%"
												>
													{{ item.title }}</span
												>
											</h5>
											<h6
												class="color-3a3c40 fw-LM fs-14 fam-mont my-2 text-truncate"
											>
												<span
													style="max-width: 100%"
													v-b-tooltip.hover="{ title: item.customerName }"
													>{{ item.customerName }}</span
												>
											</h6>

											<p
												class="m-0 p-0 text-lightgrey d-flex align-items-center fs-12 fw-LM fam-mont text-capitalize"
											>
												<img
													class="mr-1"
													src="@/assets/newdesign/resumeclinic/location.svg"
													alt=""
												/>
												<span
													v-for="index in Math.min(item.location.length, 2)"
													:key="index"
													class="text-capitalize"
												>
													{{ item.location[index - 1] }}
													<span
														v-if="
															index === Math.min(item.location.length, 2) - 1
														"
														>,&nbsp;</span
													>
												</span>
												<template v-if="item.location.length > 2">
													&nbsp;+{{ item.location.length - 2 }}&nbsp;More
												</template>
												<template v-if="item.location.length == 0">
													--
												</template>
											</p>
											<div
												class="d-flex align-items-center gap-2 mt-3"
												:class="{
													'justify-content-between':
														item.experienceRequired === '',
												}"
											>
												<div
													:class="item.experienceRequired !== '' ? 'w-40' : ''"
													class="d-flex align-items-center joblistingcard-tags text-capitalize fw-LM fs-12 fam-mont text-white"
												>
													<img
														class="mr-1"
														src="@/assets/newdesign/resumeclinic/time.svg"
														alt=""
													/>
													<span class="text-truncate">{{ item.jobType }}</span>
												</div>
												<div
													v-if="item.experienceRequired !== ''"
													class="d-flex align-items-center joblistingcard-tags fw-LM fs-12 fam-mont text-white w-45"
												>
													<img
														class="mr-1"
														src="@/assets/newdesign/resumeclinic/user.svg"
														alt=""
													/>

													<template v-if="item.experienceRequired == 'others'"
														>12+ Years</template
													>
													<template v-else>
														{{ item.experienceRequired }} Years</template
													>
												</div>
												<img
													@click="
														gotoParticularJob(
															item.jobID,
															candidateData.payload.uuid
														)
													"
													class="pointer"
													src="@/assets/newdesign/resumeclinic/blueforward.svg"
													alt=""
													id="hideinmobile"
												/>
											</div>

											<hr
												id="hideinlaptop"
												class="mb-2"
												style="opacity: unset"
											/>
											<div
												class="d-flex align-items-center justify-content-center fw-M fs-12 fam-mont color-376FAA"
												id="hideinlaptop"
											>
												Apply
												<img
													@click="
														gotoParticularJob(
															item.jobID,
															candidateData.payload.uuid
														)
													"
													class="pointer"
													src="@/assets/newdesign/resumeclinic/blueforward.svg"
													alt=""
												/>
											</div>
										</b-card>
									</div>
								</div>

								<HorizontalSliderBlog
									v-if="visibleCards.length && $refs.jobscrollContainer"
									:scrollContainerRef="$refs.jobscrollContainer"
									scrollContainerId="scrollContainer3"
								/>
							</section>
						</div>
					</div>
				</section>
				<hr class="rc-hr mt-3 mb-0" />
				<footer
					class="p-3 mobh-padding-res d-flex align-items-center justify-content-end w-100 gap-3"
				>
					<div class="builder-outline-btns mob-w50 position-relative">
						<b-button
							:style="
								buttonLoader ? 'width: 195px;height: 48px;opacity:0.5' : ''
							"
							variant="outline-secondary"
							class="mob-w100 w-200px"
							@click="triggerDownloadReport(candidateData.payload.uuid)"
						>
							<img
								v-if="!buttonLoader"
								src="../../assets/newdesign/resumeclinic/downloadicon.svg"
								class="mr-2"
								id="hideinmobile"
								alt=""
							/>
							{{ buttonLoader ? "" : "Download Report" }}
						</b-button>
						<div v-if="buttonLoader" class="loader-pos-new">
							<BlueLoader />
						</div>
					</div>
					<div
						class="primary-bluebtn mob-w50"
						v-if="!showfromhelpsection && hasAccess()"
					>
						<b-button
							@click="gobacktoFirst()"
							variant="primary"
							class="w-250px mob-w100"
						>
							<img
								id="hideinmobile"
								src="../../assets/newdesign/resumeclinic/uploadicon.svg"
								alt=""
							/>
							Upload Resume</b-button
						>
					</div>
				</footer>
			</section>
		</template>
	</b-modal>
</template>

<script>
import { getProcessedToken } from "../../utils/request.js";
import {
	resumeClinic,
	postJobSearch,
	conVerter,
	parseResume,
} from "@/utils/apiFunctions.js";
import Spinner from "@/components/fixedcomponents/Spinner.vue";
import BlueLoader from "@/components/fixedcomponents/BlueLoader.vue";
import HorizontalSliderBlog from "../../components/fixedcomponents/HorizontalScroll.vue";
import errorModal from "@/components/mixin/toast";
import successModal from "@/components/mixin/toast";
import { mapGetters } from "vuex";
import { trackFixResumeVisited, trackResumeClinicReportDownloaded, trackResumeClinicReportViewed, trackResumeClinicUsed } from '@/utils/posthogHelpers.js';
import { hasAccess, openLoginModal } from "@/utils/tokenCheck";
import EventBus from "@/utils/EventBus";
import { config } from "@/config/index.js";
import { Capacitor } from "@capacitor/core";

export default {
	data() {
		return {
			showUploadResumeagian: false,
			showAll: false,
			viewMore: true,
			suggestedCopy: [],
			firstModal: false,
			secondModal: false,
			fileData: {},
			fileName: "",
			resumeData: {},
			keyStates: {},
			loaderStatus: false,
			resumeUpLoaded: false,
			reportPayload: {},
			jobRole: "",
			jobDescription: "",
			checked: false,
			numberofcards: 10,
			itemsPerPage: 3,
			isMobile: false,
			openresumeclinicModal: this.showModal,
			jdchecked: false,
			candidateData: {},
			currentIndex: 0,
			keyfindings: [
				{ name: "Career Progression" },
				{ name: "Educational Relevance" },
				{ name: "Relevance of Experience" },
				{ name: "Industry Knowledge" },
				{ name: "Gaps in Experience" },
				// { name: "Cultural Fit" },
			],
			imageMap: {
				personal_info: require("@/assets/newdesign/resumeclinic/personalinfo.svg"),
				education: require("@/assets/newdesign/resumeclinic/education.svg"),
				experience: require("@/assets/newdesign/resumeclinic/expereince.svg"),
				projects: require("@/assets/newdesign/resumeclinic/projects.svg"),
				portfolio: require("@/assets/newdesign/resumeclinic/portfolio.svg"),
				skills: require("@/assets/newdesign/resumeclinic/skills.svg"),
				endeavours: require("@/assets/newdesign/resumeclinic/edev.svg"),
				template: require("@/assets/newdesign/resumeclinic/template.svg"),
			},
			suggestedJobs: [],
			displayCount: 3,
			slideDirection: "slide-right",
			activeAccordion: {},
			scoreColor: {
				red: "Fair",
				green: "Amazing",
				yellow: "Good",
				orange: "Okay",
			},
			loaderStatus: false,
			overallScore: null,
			reportPayload: {},
			loaderStatus2: false,
			buttonLoader: false,
			gobacktoFirstmodal: false,
			errorMessage: "",
			scrollValue: 0,
			scrollMax: 100,
			profileprogress: 0,
		};
	},
	props: {
		customClass: {
			type: String,
			default: "",
		},
		showModal: {
			type: Boolean,
		},
		showfromhelpsection: {
			type: Boolean,
			deafault: false,
		},
		clinicDatafromhs: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		showifAnalysis: {
			type: Boolean,
			deafault: false,
		},
	},
	components: {
		Spinner,
		BlueLoader,
		HorizontalSliderBlog,
	},
	mixins: [errorModal, successModal],
	beforeDestroy() {
		window.removeEventListener("resize", this.checkScreenSize);
		EventBus.$emit("resume-clinic-state", false);
		EventBus.$emit("resume-clinic-closed", false);
		EventBus.$off("mobile-menu-state", this.closingModal);
		EventBus.$off("header-search-state", this.closingModal);
	},
	mounted() {
		this.closingModal = (state) => {
			if (state && this.openresumeclinicModal) {
				this.modalClose();
			}
		};
		EventBus.$on("mobile-menu-state", this.closingModal);
		EventBus.$on("header-search-state", this.closingModal);
		this.checkScreenWidth();

		if (
			this.$route.query.downloadReport === "true" ||
			this.$route.query.downloadReport === true ||
			this.$store.getters["userVUEX/getDownloadReport"]
		) {
			this.$nextTick(() => {
				if (this.hasAccess()) {
					this.$store.commit("userVUEX/setDownloadReport", false);
					this.downloadHTML();
				}
			});
		}
	},
	watch: {
		openresumeclinicModal: {
			immediate: true,
			handler(val) {
				if (val) {
					EventBus.$emit("resume-clinic-state", val);
				} else {
					EventBus.$emit("resume-clinic-closed", val);
				}
			},
		},
	},
	computed:{
		...mapGetters("userVUEX",{
			userInfo:"getUserInfo"
		})
	},
	async created() {
		trackFixResumeVisited();
		if (
			this.clinicDatafromhs &&
			Object.keys(this.clinicDatafromhs).length > 0
		) {
			trackResumeClinicReportViewed({
				email: this.userInfo.email
			})
			this.loadExistingAnalysis(this.clinicDatafromhs);
			return;
		} else if (
			this.getcandidateInfo.resume_clinic_analysis &&
			Object.keys(this.getcandidateInfo.resume_clinic_analysis).length !== 0
		) {
			trackResumeClinicReportViewed({
				email: this.userInfo.email
			})
			this.loadExistingAnalysis(this.getcandidateInfo.resume_clinic_analysis);
			return;
		} else if (
			this.getcandidateInfo &&
			this.getcandidateInfo.resume_clinic_analysis &&
			Object.keys(this.getcandidateInfo.resume_clinic_analysis).length > 0
		) {
			console.log(
				"resume_clinic_analysis exists:",
				this.getcandidateInfo.resume_clinic_analysis
			);
		} else {
			console.log("resume_clinic_analysis is missing or empty - Guest Mode");
			this.openresumeclinicModal = true;
		}
	},
	computed: {
		isApp(){
			return Capacitor.isNativePlatform();
		},
		fromPage() {
			return this.$route.query.fromPage || null;
		},
		...mapGetters("candidateVUEX", {
			getcandidateInfo: "getcandidateInfo",
			progress: "getCandProgressResp",
		}),
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
		profileProgress() {
			return this.progress.progress;
		},
		sortedCandidateData() {
			const order = [
				"personal_info",
				"education",
				"projects",
				"portfolio",
				"skills",
				"experience",
				"endeavours",
			];

			return Object.entries(this.candidateData.payload)
				.filter(
					([key]) =>
						key !== "uuid" && key !== "overall" && key !== "resume_vs_job"
				)
				.sort((a, b) => order.indexOf(a[0]) - order.indexOf(b[0]));
		},
		visibleCards() {
			const limitedJobs = this.suggestedCopy.slice(0, 12);
			return limitedJobs;
		},
		isRightArrowDisabled() {
			return (
				this.currentIndex + this.itemsPerPage >=
				Math.min(this.suggestedCopy.length, 12)
			);
		},
		visibleJobs() {
			return this.suggestedCopy.slice(0, 6); // roughly fits 2 lines
		},

		remainingCount() {
			return this.suggestedCopy.length - this.visibleJobs.length;
		},
		overAllRating() {
			if (this.overallScore === 1) {
				return "Amazing";
			} else if (this.overallScore === 2) {
				return "Good";
			} else if (this.overallScore === 3) {
				return "Okay";
			} else {
				return "Fair";
			}
		},
		getMeterClass() {
			const score = parseInt(this.overallScore);
			switch (score) {
				case 1:
					return "modal-amzng-dial";
				case 2:
					return "modal-good-dial";
				case 3:
					return "modal-okay-dial";
				case 4:
					return "modal-fair-dial";
			}
		},
		checkIfResumeClinicAnalysisExists() {
			return (
				this.getcandidateInfo.resume_clinic_analysis &&
				Object.entries(this.getcandidateInfo.resume_clinic_analysis) !== 0
			);
		},
	},
	methods: {
		// 		 onModalShown() {
		//     const hasGuestHeader = this.customClass?.includes('guestHeader');

		//     if (hasGuestHeader) {
		//       // slight delay ensures backdrop is in DOM
		//       setTimeout(() => {
		//         const backdrop = document.querySelector('.modal-backdrop');
		//         if (backdrop) {
		//           backdrop.classList.add('guestHeader-backdrop');
		//         }
		//       }, 0);
		//     }
		//   },
		hasAccess() {
			return hasAccess();
		},
		openLoginAndGoToJobs() {
			if (this.hasAccess()) {
				this.$router.push(`/job/search?tab=hire&from=candidate`);
			} else {
				openLoginModal({
					redirectUrl: `${config.candidateBase}/job/search?tab=hire&from=candidate`,
				});
			}
		},
		openLoginModal(uuid) {
			if (this.hasAccess()) {
				this.downloadHTML();
			} else {
				this.$store.commit("userVUEX/setDownloadReport", false);
				this.$store.commit("userVUEX/setShowResumeClinic", true);
				this.$emit("openLoginModal", uuid);
			}
		},
		triggerDownloadReport(uuid) {
			if (this.hasAccess()) {
				this.downloadHTML();
			} else {
				this.$store.commit("userVUEX/setShowResumeClinic", false);
				this.$store.commit("userVUEX/setDownloadReport", true);
				this.$emit("openLoginModal", uuid);
			}
		},
		loadExistingAnalysis(data) {
			this.loaderStatus2 = true;

			this.candidateData.payload = data;
			this.reportPayload = {
				payload: {
					...data,
					email: data.candidate_email,
					name: data.candidate_name,
				},
			};

			const jobPayload = {
				skills: data.overall.keywords,
				govtJobs: false,
				home: true,
			};

			// Fetch job roles → THEN open modal with results
			this.getJobDetails(jobPayload);
		},
		gobacktoFirst() {
			this.gobacktoFirstmodal = true;
			this.firstModal = false;
			this.secondModal = false;
			this.showfromhelpsection = false;
			this.fileName = "";
		},
		async downloadHTML() {
			try {
				this.loaderStatus = true;
				this.buttonLoader = true;
				const res = await conVerter(this.reportPayload);
				if (res.status === 200) {
					const url = window.URL.createObjectURL(
						new Blob([res.data], { type: "application/pdf" })
					);

					// window.open(url);
					const link = document.createElement("a");
					link.href = url;
					link.download = "Hire3x Report.pdf";
					link.click();
					// window.open(res.data.link);
					console.log(res, "parsed");
					this.loaderStatus = false;
					this.buttonLoader = false;
					trackResumeClinicReportDownloaded({
						email:this.userInfo.email
					})
					this.successModal(
						"Successfully downloaded.",
						"The report was downloaded successfully."
					);
				} else {
					this.loaderStatus = false;
					console.error("Error:", res);
				}
			} catch (error) {
				this.loaderStatus = false;
				this.buttonLoader = false;
				console.error("Failed to convert HTML:", error);
			}
		},

		loadMore() {
			if (this.currentIndex + this.itemsPerPage < this.suggestedCopy.length) {
				this.slideDirection = "slide-right";
				this.currentIndex += this.itemsPerPage;
			}
		},
		loadLess() {
			if (this.currentIndex > 0) {
				this.slideDirection = "slide-left";
				this.currentIndex -= this.itemsPerPage;
			}
		},
		checkScreenWidth() {
			this.isMobile = window.innerWidth <= 1028; // For mobile and tablet (screen width <= 1028px)
		},
		triggerFileInput() {
			this.onModalShown();
			// Trigger the file input click event programmatically
			this.$refs.fileInput.click();
		},
		modalClose() {
			this.openresumeclinicModal = false;
			this.$bvModal.hide("resumeclinicmodal");
			this.$emit("modalClose");
			this.firstModal = false;
			this.secondModal = false;
			this.loaderStatus = false;
			if (this.customClass) {
				const backdrops = document.querySelectorAll(".modal-backdrop");
				backdrops.forEach((b) => {
					b.style.top = "";
				});
			}
		},
		onModalShown() {
			const hasGuestHeader = this.customClass?.includes("guestHeader");

			if (hasGuestHeader) {
				// slight delay ensures backdrop is in DOM
				setTimeout(() => {
					const backdrop = document.querySelector(".modal-backdrop");
					if (backdrop) {
						backdrop.classList.add("guestHeader-backdrop");
					}
				}, 0);
			}
		},
		scrollToAccordion(index) {
			// Get the target accordion element
			const target = this.$refs[`accordion-${index}`]?.[0];
			if (target) {
				target.scrollIntoView({ behavior: "smooth", block: "center" });
				this.toggleAccordion(index);
			}
		},
		toggleAccordion(index) {
			// Open the accordion when clicking on the left-side item
			this.$set(this.activeAccordion, index, !this.activeAccordion[index]);
		},
		handleFileUpload(event) {
			this.onModalShown();
			const file = event.target.files[0];
			if (file) {
				if (file.size > 10 * 1024 * 1024) {
					this.errorMessage =
						"File size exceeds 10MB. Please upload a smaller file.";
					this.fileData = null;
					this.fileName = "";
					return;
				}
				const allowedTypes = [
					"application/pdf",
					"application/msword",
					"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
				];

				if (!allowedTypes.includes(file.type)) {
					this.errorMessage =
						"Only PDF and Word documents (.pdf,.docx) are allowed.";
					this.fileData = null;
					this.fileName = "";
					return;
				}
				this.fileData = file;
				this.fileName = file.name;
				this.errorMessage = "";
			}
			console.log(this.fileData);
		},
		deleteFile() {
			this.fileName = "";
			this.fileData = null;
			this.$refs.fileInput.value = "";
		},
		async getJobDetails(jobPayload) {
			try {
				const res2 = await postJobSearch(jobPayload);
				if (res2.status === 200) {
					this.suggestedJobs = res2.data.data.data;
					this.suggestedCopy = [...this.suggestedJobs];
					this.overallScore = this.candidateData.payload.overall.rating;
					this.loaderStatus = false;
					this.firstModal = true;
					this.secondModal = false;
					this.loaderStatus2 = false;
					this.openresumeclinicModal = true;
					this.$bvModal.show("resumeclinicmodal");
				}
			} catch (error) {
				console.log(error);
			}
		},
		async uploadresume() {
			this.onModalShown();
			this.gobacktoFirstmodal = false;
			this.secondModal = true;
			this.loaderStatus = true;
			let form = new FormData();
			form.append("file", this.fileData);
			form.append("userID", getProcessedToken());
			if (this.jdchecked) {
				form.append("role", this.jobRole);
				form.append("description", this.jobDescription);
			}

			try {
				const res = await resumeClinic(form);

				if (res.status === 200) {
					this.loaderStatus = true;
					this.candidateData = res.data;
					this.reportPayload = {
						payload: {
							...res.data.payload,
							email: res.data.payload.candidate_email,
							name: res.data.payload.candidate_name,
						},
					};
					this.onModalShown();
					const jobPayload = {
						skills: this.candidateData.payload.overall.keywords,
						govtJobs: false,
						home: true,
					};
					trackResumeClinicUsed({
						email:this.userInfo.email
					})
					this.getJobDetails(jobPayload);
					this.onModalShown();
				}
			} catch (error) {
				console.error("Error uploading resume:", error);
			}
		},

		async jobscrollCheck() {
			const temp = [...this.suggestedJobs];
			this.suggestedJobs = [];
			await this.$nextTick();
			let checkScroll = this.checkScroll();
			let index = 0;
			while (!checkScroll && index < temp.length) {
				this.suggestedJobs.push(temp[index++]);
				await this.$nextTick();
				checkScroll = this.checkScroll();
			}
			if (checkScroll) {
				this.suggestedJobs.pop();
			}
			this.viewMore = this.suggestedJobs.length < temp.length;
			await this.$nextTick();
			if (this.viewMore) {
				checkScroll = this.checkScroll();
				if (checkScroll) {
					this.suggestedJobs.pop();
				}
			}
			this.suggestedCopy = temp;
		},

		// async jobscrollCheck() {
		//   const temp = [...this.suggestedJobs];
		//   let checkScroll = this.checkScroll();

		//   while (checkScroll) {
		//     const data = [...this.suggestedJobs];
		//     let len = data.length;
		//     let half = Math.floor(len / 2);
		//     this.suggestedJobs.splice(0, half);
		//     await this.$nextTick();
		//     checkScroll = this.checkScroll();
		//   }
		//   for (let i = suggestedJobs.length; i <= 30; i++) {
		//     checkScroll = this.checkScroll();
		//     if (!checkScroll) {
		//       this.suggestedJobs.push(temp[i]);
		//     } else {
		//       this.suggestedJobs.pop();
		//       break;
		//     }
		//     await this.$nextTick();
		//   }
		//   this.viewMore = this.suggestedJobs.length < temp.length;
		//   await this.$nextTick();
		//   if (this.viewMore) {
		//     checkScroll = this.checkScroll();
		//     if (checkScroll) {
		//       this.suggestedJobs.pop();
		//     }
		//   }
		//   this.suggestedCopy = temp;
		// },

		checkScroll() {
			const jobContainer = this.$refs.jobsContainer;
			if (
				jobContainer &&
				jobContainer.scrollHeight > jobContainer.clientHeight
			) {
				return true;
			} else {
				return false;
			}
		},
		gotoParticularJob(jobID, uuid) {
			if (this.hasAccess()) {
				// 1️ Store flag in session (this survives swipe-back)
				sessionStorage.setItem("fromResumeClinic", "1");

				const query = {
					jobID,
					from: "resumeclinicModal",
					fromPage: this.$route.name,
				};

				// 2️ Push next route normally
				this.$router.push({
					name: "JobSearch",
					query,
				});
			} else {
				this.$emit("openLoginModalWithJobID", jobID, uuid);
			}
		},
	},
};
</script>

<style>
.w-250px {
	width: 250px;
}
.rc-hr {
	border-top: 1px solid #a6a9ad;
}
#resumeclinicmodal .modal-body {
	padding: 0;
}

.rotating-border {
	position: relative;
	width: 100%;
	border-radius: 8px;
	background-size: 300% 300%;
	animation: rotate-gradient 2s linear infinite; /* Rotate the gradient */
	padding: 3px; /* Space for the border */
}

/* Inner card content */
.res-card-content {
	width: 100%;
	height: 100%;
	background: #ffffff;
	box-shadow: 0px 0px 13.9067px rgba(0, 0, 0, 0.07);
	border-radius: 14px;
	padding: 15px;
}

/* Animation for the gradient rotation */
@keyframes rotate-gradient {
	0% {
		background-position: 0% 5%;
		background: linear-gradient(0deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	5% {
		background-position: 5% 10%;
		background: linear-gradient(18deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	10% {
		background-position: 10% 15%;
		background: linear-gradient(36deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	15% {
		background-position: 15% 20%;
		background: linear-gradient(54deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	20% {
		background-position: 20% 25%;
		background: linear-gradient(72deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	25% {
		background-position: 25% 30%;
		background: linear-gradient(90deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	30% {
		background-position: 30% 35%;
		background: linear-gradient(108deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	35% {
		background-position: 35% 40%;
		background: linear-gradient(126deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	40% {
		background-position: 40% 45%;
		background: linear-gradient(144deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	45% {
		background-position: 45% 50%;
		background: linear-gradient(162deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	50% {
		background-position: 50% 55%;
		background: linear-gradient(180deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	55% {
		background-position: 55% 60%;
		background: linear-gradient(198deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	60% {
		background-position: 60% 65%;
		background: linear-gradient(216deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	65% {
		background-position: 65% 70%;
		background: linear-gradient(234deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	70% {
		background-position: 70% 75%;
		background: linear-gradient(252deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	75% {
		background-position: 75% 80%;
		background: linear-gradient(270deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	80% {
		background-position: 80% 85%;
		background: linear-gradient(288deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	85% {
		background-position: 85% 90%;
		background: linear-gradient(306deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	90% {
		background-position: 90% 95%;
		background: linear-gradient(324deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	95% {
		background-position: 95% 100%;
		background: linear-gradient(342deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
	100% {
		background-position: 100% 0%;
		background: linear-gradient(360deg, #20639b, #ffffff, #ffffff);
		/* transition: all 0.3s linear; */
	}
}
.ml-6px {
	margin-left: 6px;
}
.pl-60 {
	padding-left: 60px;
}
/* rotating border end */

.rc-compare-container {
	padding: 12px 16px;
	background: #f0f4ff;
	border: 1px solid rgba(224, 224, 224, 0.3);
	border-radius: 8px;
}
.resumeclinic-inputs .form-control {
	height: 50px;
	padding: 12px;
	background: #ffffff;
	border: 1px solid #d9d9d9;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 6px;
}
.resumeclinic-textarea .form-control {
	padding: 12px;
	background: #ffffff;
	border: 1px solid #d9d9d9;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 6px;
	min-height: 138px;
}
.custom-control-input:checked ~ .custom-control-label::before {
	background-color: #20639b;
	border-color: #20639b;
}
.rc-linealignment {
	position: relative;
	left: 14px;
	height: 50px;
}
.rc-result-left-top {
	background: linear-gradient(180deg, #7898c7 -100%, #091e34 100%);
	border-radius: 8px;
	overflow: hidden;
}
.color-F9C82B {
	color: #f9c82b;
}
.rc-result-top-cards {
	padding: 7px 12px;
	height: 40px;
	background: #ffffff;
	border: 1px solid rgba(46, 66, 93, 0.08);
	box-shadow: 0px 2px 24px rgba(98, 114, 144, 0.1);
	border-radius: 4px;
}
.rc-res-left-card-boxes {
	width: 14px;
	height: 14px;
	border-radius: 2px;
}
.bg-boxred {
	background: #ec0d06;
}
.bg-boxgreen {
	background: #2aa869;
}
.bg-boxorange {
	background: #ef9727;
}
.bg-boxyellow {
	background: #f9c82b;
}
.rc-reviewtag {
	padding: 2px 10px;
	background: rgba(255, 224, 116, 0.29);
	border-radius: 20px;
	color: #cd8428;
}
.rc-result-right-top {
	padding: 16px;
	background: linear-gradient(0deg, #2e425d, #2e425d), #ffffff;
	border-radius: 12px;
}
.color-ad1927 {
	color: #ad1927;
}
.rc-rrt-subbars {
	padding: 0px 16px;
	background: rgba(255, 255, 255, 0.35);
	border-radius: 4px;
	color: #1a4164;
}
.rc-suggested-tags {
	padding: 8px 12px;
	background: linear-gradient(
		180deg,
		rgba(255, 255, 255, 0.1) 0%,
		rgba(255, 255, 255, 0.05) 100%
	);
	box-shadow: 0px 0px 4px rgba(0, 255, 255, 0.4);
	/* backdrop-filter: blur(10.8126px); */
	border-radius: 20px;
}
.joblistingcards .card {
	width: 250px;
	background: rgba(82, 166, 255, 0.08);
	border-radius: 8px;
	flex-shrink: 0;
}
.joblistingcards .card-body {
	padding: 10px;
}
.joblistingcard-tags {
	padding: 0 8px;
	background: #376faa;
	border-radius: 4px;
}
.accordioncards .card {
	background: #ffffff;
	box-shadow: 0px 2px 24px rgba(98, 114, 144, 0.1);
	border-radius: 8px;
}
.accordioncards .card-header {
	padding: 10px;
	height: 52px;
	background: #ffffff;
	/* box-shadow: 0px 2px 24px rgba(98, 114, 144, 0.1); */
	border-radius: 8px 8px 0px 0;
	border-bottom: 1px solid #d2e0eb;
	margin: 0 3px;
}
.accordioncards .card-body {
	padding: 10px;
	background: #ffffff;
	box-shadow: 0px 2px 24px rgba(98, 114, 144, 0.1);
}
.fairtag {
	padding: 2px 15px;
	background: rgba(215, 52, 44, 0.1);
	border-radius: 20px;
	font-family: "Lato", sans-serif;
	font-weight: 700;
	font-size: 14px;
	text-transform: uppercase;
	color: #d7342c;
}
.okaytag {
	padding: 2px 15px;
	background: rgba(249, 179, 132, 0.45);
	border-radius: 20px;
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 700;
	font-size: 14px;
	text-transform: uppercase;
	color: #f47529;
}
.goodtag {
	padding: 2px 15px;
	background: rgba(255, 221, 128, 0.45);
	border-radius: 20px;
	font-family: "Lato", sans-serif;
	font-weight: 700;
	font-size: 14px;
	text-transform: uppercase;
	color: #ef9727;
}
.amzngtag {
	padding: 2px 15px;
	background: #e6f4e6;
	border-radius: 20px;
	font-family: "Lato", sans-serif;
	font-weight: 700;
	font-size: 14px;
	text-transform: uppercase;
	color: #038e00;
}
.questionmarktag {
	padding: 2px 15px;
	background: #dadada;
	border-radius: 20px;
	font-family: "Lato", sans-serif;
	font-weight: 700;
	font-size: 14px;
	text-transform: uppercase;
	color: #8c8c8c;
}
.fileinputcontainer {
	padding: 5px 16px;
	background: rgba(32, 99, 155, 0.2);
	border-radius: 8px;
}

/* Slide Left (For Load Less) */
.slide-left-enter-active,
.slide-left-leave-active {
	transition: all 0.5s ease-in-out;
}
.slide-left-enter {
	opacity: 0;
	transform: translateX(-100%);
}
.slide-left-leave-to {
	opacity: 0;
	transform: translateX(100%);
}

/* Slide Right (For Load More) */
.slide-right-enter-active,
.slide-right-leave-active {
	transition: all 0.5s ease-in-out;
}
.slide-right-enter {
	opacity: 0;
	transform: translateX(100%);
}
.slide-right-leave-to {
	opacity: 0;
	transform: translateX(-100%);
}
.template3-height {
	height: calc(100vh - 290px);
	overflow-y: auto;
}
@media (min-width: 1200px) {
	#resumeclinicmodal .modal-xl {
		max-width: 1155px;
	}
}
#resumeclinicmodal .modal-dialog {
	min-height: calc(100% - 4em);
	margin: 4rem auto 0 auto;
}

.primary-bluebtn .btn-primary {
	background: #52a6ff;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-color: unset;
	color: #fbfbfb;
	position: relative; /* For the ::before pseudo-element */
	overflow: hidden; /* Ensures the pseudo-element stays within the button */
	z-index: 1;
}

.primary-bluebtn .btn {
	height: 48px;
	border-radius: 8px;
	padding: 12px;
	font-family: "Manrope", sans-serif;
	font-weight: 800;
	font-size: 16px;
	color: #fbfbfb;
	border: none !important;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
}
.primary-bluebtn .btn-primary:focus {
	background-color: #20639b !important;
}

/* Hover effect for the button */
.primary-bluebtn .btn-primary:hover {
	/* background: #0055d4;
  box-shadow: 0px 1px 1px rgba(8, 8, 8, 0.08), 0px 1px 1px rgba(8, 8, 8, 0.2),
    inset 0px 6px 12px rgba(255, 255, 255, 0.12),
    inset 0px 1px 1px rgba(255, 255, 255, 0.2);
  border-radius: 4px; */
	color: #fff; /* Text color on hover */
	border-color: unset; /* Border color on hover */
	background-color: #20639b;
	border: none;
}

/* Focus state */
.primary-bluebtn .btn-primary:not(:disabled):not(.disabled):active:focus,
.primary-bluebtn .btn-primary:not(:disabled):not(.disabled).active:focus,
.primary-bluebtn .show > .btn-primary.dropdown-toggle:focus {
	box-shadow: unset;
	border-color: #20639b; /* Border color on hover */
	background-color: #20639b;
	border: none;
}
.primary-bluebtn .btn-primary:not(:disabled):not(.disabled):active,
.primary-bluebtn .btn-primary:not(:disabled):not(.disabled).active,
.primary-bluebtn .show > .btn-primary.dropdown-toggle {
	color: #fff;
	border-color: #20639b; /* Border color on hover */
	background-color: #20639b;
	border: none;
}
.primary-bluebtn .btn-primary:not(:disabled):hover {
	color: #fff; /* Text color on hover */
	background-color: #20639b;
	border: none;
}

/* Remove hover, focus, and active states when disabled */
.primary-bluebtn .btn-primary:disabled,
.primary-bluebtn .btn-primary:disabled:hover,
.primary-bluebtn .btn-primary:disabled:focus,
.primary-bluebtn .btn-primary:disabled:active {
	background-color: #20639b !important; /* Set a disabled color */
	color: #fff !important;
	cursor: not-allowed !important;
	border: none;
	box-shadow: none !important;
	pointer-events: none; /* Prevents any interactions */
}
/* 
@media (min-width: 1029px) {
	.primary-bluebtn .btn::before {
		content: "";
		position: absolute;
		inset: 0;
		background-color: #1e4f8b;
		transform: translateY(100%);
		border-radius: 0 0 100px 100px;
		z-index: -1;
		transition: none;
	}

	.primary-bluebtn .btn:hover::before {
		animation: fillAnimation 0.3s ease forwards;
	}

	.primary-bluebtn .btn:not(:hover)::before {
		animation: reverseFillAnimation 0.3s ease forwards;
	}
}

@keyframes fillAnimation {
	0% {
		transform: translateY(100%);
		border-radius: 0 0 50px 50px;
		background-color: #7da4d4;
	}
	20% {
		transform: translateY(70%);
		border-radius: 40px 40px 0 0;
		background-color: #7da4d4;
	}
	80% {
		transform: translateY(0);
		border-radius: 40px 40px 0 0;
	}
	90% {
		transform: translateY(0);
		border-radius: 20px 20px 0 0;
	}
	95% {
		transform: translateY(0);
		border-radius: 10px 10px 0 0;
	}
	100% {
		transform: translateY(0);
		border-radius: 0 0 0 0;
		background-color: #1e4f8b;
	}
}

@keyframes reverseFillAnimation {
	0% {
		transform: translateY(0);
		border-radius: 0 0 0 0;
		background-color: #1e4f8b;
	}
	5% {
		transform: translateY(0);
		border-radius: 10px 10px 0 0;
	}
	10% {
		transform: translateY(0);
		border-radius: 20px 20px 0 0;
	}
	80% {
		transform: translateY(0);
		border-radius: 40px 40px 0 0;
	}
	100% {
		transform: translateY(100%);
		border-radius: 0 0 50px 50px;
		background-color: #507fb8;
	}
}
*/

:focus-visible {
	outline: unset;
}

.w-30 {
	width: 30%;
}
.w-70 {
	width: 70%;
}
#resumeclinicmodal .modal {
	overflow-y: hidden;
}
.modal-backdrop.guestHeader-backdrop {
	top: 0px !important;
}
@media (max-width: 1028px) {
	.mobh-thirdscreen-res-android {
        height: calc(100dvh - 395px) !important;
    }
	.mobh-thirdscreen-res {
		height: calc(100dvh - 345px) !important;
	}
	.mobh-padding-res {
		padding: 0 16px 5px 16px !important;
	}
	.suggestedjobs {
		max-height: unset !important;
	}
	.mob-txt-left {
		text-align: left;
	}
	.accordioncards .card-body {
		text-align: left;
	}
	.joblistingcards .card-body {
		text-align: left;
	}
	.mobile-text-left {
		text-align: left;
	}
	.mobilecloseicon {
		position: absolute;
		top: 8px;
		right: 8px;
	}
	.mob-w50 {
		width: 50% !important;
	}
	#resumeclinicmodal .modal-body {
		padding: 0;
		background: #f7f9fc;
		padding-bottom: env(safe-area-inset-bottom) !important;
	}
	.mob-w100 {
		width: 100% !important;
	}
	.mob-d-block {
		display: block !important;
	}
	.mob-txt-center {
		text-align: center !important;
	}
	.resume-upload-btn {
		position: absolute;
		bottom: -20px;
	}
	.template3-height {
		height: calc(
			100dvh - (215px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		);
		max-height: unset;
		overflow-y: auto;
		overflow-x: hidden;
	}
	.mobh-unset {
		height: unset !important;
	}
	.mobp-3 {
		padding: 1rem !important;
	}
	.moboverflowx-auto {
		overflow-x: auto;
		white-space: nowrap;
	}
	.builder-outline-btns .btn {
		font-size: 14px !important;
	}
	.primary-bluebtn .btn {
		font-size: 14px !important;
	}
	#resumeclinicmodal___BV_modal_outer_ {
		z-index: 1039 !important;
	}
	.mob-justify-unset {
		justify-content: unset !important;
	}
	.mob-mt30px {
		margin-top: 30px;
	}
	.mobflexrow {
		flex-direction: row !important;
	}
	.mobpadding15px {
		padding: 15px;
	}
}

.noborder {
	border: unset !important;
	display: none;
}
@media (max-width: 600px) {
	#resumeclinicmodal .modal-dialog {
		margin: 0;
	}
	#resumeclinicmodal .modal {
		z-index: 2070;
	}
	#resumeclinicmodal .modal-content {
		top: env(safe-area-inset-top);
		height: calc(
			100dvh - (env(safe-area-inset-top) + env(safe-area-inset-bottom))
		);
		bottom: env(safe-area-inset-bottom);
		/* commented due to outer scroll issue in mobile */
		/* overflow: auto; */
		/* padding-top: env(safe-area-inset-top); */
	}
	#resumeclinicmodal .mobile-header {
		z-index: unset;
	}
	.unlockbtn {
		left: 25% !important;
		top: 30% !important;
	}
}
.unlockbtn {
	left: 43%;
	top: 20%;
}
.rotate-on-hover:hover {
	transition: transform 0.5s ease;
	transform: rotate(-2deg);
}
@media (min-width: 576px) {
	#resumeclinicmodal .modal-dialog-centered {
		min-height: calc(100% - 5rem);
	}
}
@media (min-width: 576px) {
	#resumeclinicmodal .modal-dialog {
		margin: 4rem auto 0 auto;
	}
}
.builder-outline-btns .btn-outline-secondary {
	background: #ffffff;
	border: 1px solid #295380;
	border-radius: 50px;
}
.builder-outline-btns .btn-outline-secondary:hover {
	color: #2e425d;
	background-color: #ffffff;
	border-color: #295380;
}
.builder-outline-btns
	.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
	color: #2e425d;
	background-color: #ffffff;
	border-color: #295380;
}
.primary-bluebtn .btn-primary,
.primary-bluebtn .btn-primary:hover,
.primary-bluebtn .btn-primary:active,
.primary-bluebtn .btn-primary:focus,
.primary-bluebtn .btn-primary:not(:disabled):not(.disabled):active,
.primary-bluebtn .btn-primary:not(:disabled):not(.disabled).active,
.show > .primary-bluebtn .btn-primary.dropdown-toggle {
	background-color: #20639b !important;
	border-color: #20639b !important;
	border-radius: 50px !important;
}
.builder-outline-btns
	.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,
.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-secondary.dropdown-toggle:focus {
	box-shadow: unset;
}
.builder-outline-btns .btn {
	height: 48px;
	padding: 12px;
	font-family: "Roboto", sans-serif;
	font-weight: 800;
	font-size: 16px;
	letter-spacing: 0.5px;
	color: #2e425d;
}
.opacityblackarw {
	opacity: 0.5;
}
.uplod-error-box {
	border: 2px dashed #cb3d00;
	box-shadow: 0px 11.6745px 14.0094px -2.33491px rgba(16, 24, 40, 0.1),
		0px 4.66981px 4.66981px -2.33491px rgba(16, 24, 40, 0.04);
	border-radius: 7.00472px;
}
.uploaded-green-border {
	border: 3px solid #039855;
	box-shadow: 0px 11.6745px 14.0094px -2.33491px rgba(16, 24, 40, 0.1),
		0px 4.66981px 4.66981px -2.33491px rgba(16, 24, 40, 0.04);
	border-radius: 7.00472px;
}
.color-376FAA {
	color: #376faa;
}
.parsedtagsize {
	width: 100px;
	text-align: center;
}

.suggestedjobs::-webkit-scrollbar {
	width: 1px;
	height: 0;
}
.suggestedjobs::-webkit-scrollbar-thumb {
	background: linear-gradient(0deg, #2e425d, #2e425d), #ffffff;
}
.suggestedjobs::-webkit-scrollbar-track {
	background: linear-gradient(0deg, #2e425d, #2e425d), #ffffff;
}
.modal-okay-dial {
	bottom: 5px;
	left: 34px;
	transform: rotate(60deg);
}
.modal-good-dial {
	bottom: 7px;
	left: 41px;
	transform: rotate(116deg);
}
.modal-fair-dial {
	bottom: -3px;
	left: 25px;
	transform: rotate(16deg);
}
.modal-amzng-dial {
	left: 53px;
	bottom: -1px;
	transform: rotate(156deg);
}
.joblistingcards::-webkit-scrollbar {
	scroll-behavior: smooth !important;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}
.suggestedjobs {
	display: -webkit-box;
	-webkit-line-clamp: 2; /* show only 2 rows */
	-webkit-box-orient: vertical;
	overflow: hidden;

	max-height: calc(60px * 2); /* 2 lines */
}
.place-center {
	place-items: center;
	place-content: center;
}

.blurbackground .card-text {
	background: rgba(240, 244, 248, 0.4);
	filter: blur(5px);
}

.unlockbtn .btn {
	height: 35px;
}
</style>
